import { ControlledAutocompleteTransformProp } from '../components/form-items/ControlledAutocomplete';

export const approverDropdownTransform: ControlledAutocompleteTransformProp = {
  input: (selectedOption, options) => {
    const selected = options.find(({ id }) => id === selectedOption);
    return selected ?? null;
  },
  output: (selectedOption) => (selectedOption ? selectedOption.id : null),
};

export const keyValueResponseTransform: ControlledAutocompleteTransformProp = {
  input: (selectedOption, options) => {
    const selected = options.find(({ code }) => code === selectedOption);
    return selected ?? null;
  },
  output: (selectedOption) => (selectedOption ? selectedOption.code : null),
};
